// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as OrderRepo from "./OrderRepo.bs.js";
import * as DummyOrderRepo from "./DummyOrderRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyOrderRepo.OrderRepo;
  } else {
    return OrderRepo.OrderRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
